import { render, staticRenderFns } from "./BufferDialog.vue?vue&type=template&id=5cc905ad&scoped=true&"
import script from "./BufferDialog.vue?vue&type=script&lang=js&"
export * from "./BufferDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc905ad",
  null
  
)

export default component.exports